import { useState,useEffect ,useRef} from "react";
import { FaSearch,FaInfoCircle,FaPlus, FaSync } from "react-icons/fa";
import Pagination from "../components/Pagination";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";
import Lookup from "../components/Lookup";
import StudentFeeDetails from "../pages/StudentFeeDetails";


export default function StudentAcademic() {
const [errors, setErrors] = useState([]);
const [successMessage, setSuccessMessage] = useState("");
const [showPaymentDetails, setShowPaymentDetails] = useState(false);
 const [studentAcademics, setStudentAcademics] = useState([]);
 const [activeLookup, setActiveLookup] = useState(null);
  const [nameSearch, setNameSearch] = useState("");
  const [classFilter, setClassFilter] = useState("");
  const [classes, setClasses] = useState([]);
  const [selectedStudentAcademic, setSelectedStudentAcademic] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
   const [loading, setLoading] = useState(false);
   const hasFetched = useRef(false);
    const hasClassFetched = useRef(false);
  
    useEffect(() => {
        if (hasClassFetched.current) return;
        hasClassFetched.current = true;
        loadClasses();
    }, []);

   const loadClasses = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/classes");
      setClasses(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  
  useEffect(() => {
    if (hasFetched.current) return;
      hasFetched.current = true;
    loadStudentAcademics();
  }, []);

  const loadStudentAcademics = async () => {
    try {
       setLoading(true);
      const response = await axiosInstance.get("/stdntAcademic");
      setStudentAcademics(response.data);

    } catch (error) {
      console.error("Error loading student Academics", error);
    }finally{
       setLoading(false);
    }
  };
  const onClosePopup = () => {
    setErrors([]);
    setSuccessMessage("");
    setSelectedStudentAcademic(null);
    loadStudentAcademics();
  };
  const handleSave  = async () => {//Save Logic
    try {
        setLoading(true);
        setErrors([]);
        setSuccessMessage("");
        const response = await axiosInstance.post("/stdntAcademic/save", selectedStudentAcademic);
        if (response.data.status === "SUCCESS") {
            setSuccessMessage("Saved successfully");
            selectedStudentAcademic(response.data.data);
           // loadStudentAcademics();
        } else {
            if (response.data.errors && response.data.errors.length > 0) {
                // alert(response.data.errors.join("\n")); // show all errors
                setErrors(response.data.errors);
            } else {
                // alert(response.message || "Error in Save");
                setErrors(["Error in Save"]);

            }
        }
    } catch (error) {
      console.log(["Error in Save"]);
    }finally{
        setLoading(false);
    }
  };
  // Filtering logic
  const filteredStudents = studentAcademics?studentAcademics.filter((academic) => {
    const name = academic.studentName || "";
    const className = academic.className || "";
    const matchesName =
      name.toLowerCase().includes(nameSearch.toLowerCase());

    const matchesClass =
      classFilter === "" || className === classFilter;

    return matchesName && matchesClass;
  }):[];

  // Unique class list for dropdown
  //const uniqueClasses = [...new Set(studentAcademics.map(s => s.className))];
//   const uniqueClasses = Object.values(
//     studentAcademics.reduce((acc, s) => {
//         acc[s.classId] = {
//         classId: s.classId,
//         className: s.className
//         };
//         return acc;
//     }, {}));
  // Pagination logic
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentStudents = filteredStudents?filteredStudents.slice(indexOfFirst, indexOfLast):[];
  const handleChange = (e) => {const { name, value } = e.target;
    setSelectedStudentAcademic({
      ...selectedStudentAcademic,
      [name]: value
    });
  };

  const handleClassChange = (e) => {const { name, value } = e.target;
    setSelectedStudentAcademic({
      ...selectedStudentAcademic,
      [name]: value,
      sectionId: "",
      sectionName:""
    });
  };
  return (
    <div>

      {/* Header Section */}
     <div className="flex justify-between items-center mb-2">
        {loading && <Loader />}
        <h2 className="text-2xl font-bold">Academic Students</h2>

        <div className="hidden md:flex gap-3">

          {/* Refresh Button */}
          <button
            onClick={loadStudentAcademics}
            className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded flex items-center gap-2"
          >
            🔄 Refresh
          </button>

          {/* New Student Button */}
          <button
            onClick={() => {
              setSelectedStudentAcademic({
              admissionNo: "",
              classId: "",
              className:"",
              sectionId:"",
              sectionName:"",
              isActive:"Yes",
              rollNumber: "",
              feeStatus: "Pending",
              });
             // setShowModal(true);
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            + New
          </button>
        </div>
        <div className="flex md:hidden gap-3 text-xl">

          <button 
          onClick={loadStudentAcademics}
          className="p-2 bg-gray-200 rounded-full">
            <FaSync />
          </button>
          <button  onClick={() => {
              setSelectedStudentAcademic({
              admissionNo: "",
              classId: "",
              rollNumber: "",
              feeStatus: "Pending",

              
              });
             // setShowModal(true);
            }}
            className="p-2 bg-blue-600 text-white rounded-full">
            <FaPlus />
          </button>
        </div>
      </div>
      {/* Filters Section */}
      <div className="flex flex-col md:flex-row gap-4 mb-2">

        {/* Name Search */}
        <input
          type="text"
          placeholder="Search by name..."
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={nameSearch}
          onChange={(e) => {
            setNameSearch(e.target.value);
            setCurrentPage(1);
            }}
        />

        {/* Class Dropdown */}
        <select
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={classFilter}
          onChange={(e) => {
            setClassFilter(e.target.value);
            setCurrentPage(1);
            }}
        >
        <option value="">All Classes</option>
         {classes.map(cls => (
            <option key={cls.id} value={cls.className}>
            {cls.className}
            </option>
        ))}
        </select>

      </div>
      
      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-x-auto">
        <Pagination
        totalItems={filteredStudents.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setItemsPerPage={setItemsPerPage}
        />
        <table className="w-full text-left">
          <thead className="bg-gray-100 text-gray-600" >
            <tr>
              <th className="p-4">Roll No</th>
              <th className="p-4">Name</th>
              <th className="p-4">Class</th>
              <th className="p-4">Section</th>
              <th className="p-4">Active</th>
              <th className="p-4">Fee Status</th>
            </tr>
          </thead>

          <tbody>
            {filteredStudents.length > 0 ? (
             currentStudents.map((academic) => (
                <tr
                  key={academic.id}
                  className="border-t hover:bg-gray-50 transition"
                >
                  <td className="p-4">
                    <div className="flex items-center gap-2">
                       {academic.rollNumber}
                        <button  onClick={() => setSelectedStudentAcademic(academic)} className="text-gray-500 hover:text-blue-600" >
                        <FaInfoCircle size={14} />
                        </button>
                    </div>
                  </td>
                  <td className="p-4">{academic.studentName}</td>
                  <td className="p-4">{academic.className}</td>
                  <td className="p-4">{academic.sectionName}</td>
                  <td className="p-4">{academic.isActive}</td>
                  <td className="p-2">
                    <div className="flex items-center gap-2">
                       {academic.feeStatus?academic.feeStatus:"Pending"}
                        <button  onClick={() => setShowPaymentDetails(true)} 
                        className="text-gray-500 hover:text-blue-600" >
                        <FaInfoCircle size={14} />
                        </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">
                  No students found
                </td>
              </tr>
            )}
          </tbody>

        </table>
       
        {selectedStudentAcademic && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
             {loading && <Loader />}
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl p-6 relative">
              {/* Close */}
              <button
                onClick={onClosePopup}
                className="absolute top-3 right-3 text-gray-500 hover:text-black"
              >
                ✕
              </button>

              {/* Profile Header */}
              <div className="flex items-center gap-4 mb-6 border-b pb-4">
                <img
                  src={selectedStudentAcademic.photo || "/default-student.png"}
                  alt="profile" 
                  className="w-20 h-20 rounded-full object-cover border"
                />
              </div>
              {/* Error block */}
              {errors.length > 0 && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mt-2">
                  <ul className="list-disc list-inside text-sm">
                    {errors.map((err, idx) => (
                      <li key={idx}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Success message */}
              {successMessage && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded mt-2 text-sm">
                  {successMessage}
                </div>
              )}
              {/* Student Details */}
              <h4 className="text-lg font-semibold mb-3">Student Details</h4>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 text-sm mb-6">

                <div>
                  <label className="font-medium">Admission No</label>
                  <input
                    type="text"
                     onChange={handleChange}
                     name="admissionNo"
                    value={selectedStudentAcademic.admissionNo || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Student Name</label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="studentName"
                    value={selectedStudentAcademic.studentName || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Roll No</label>
                  <input
                    type="text"
                     onChange={handleChange}
                     name="rollNumber"
                    value={selectedStudentAcademic.rollNumber || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Class</label>
                  <select
                    value={selectedStudentAcademic.classId || ""}
                    onChange={handleClassChange}
                    name="classId"
                    className="w-full border rounded px-2 py-1"
                  >
                    <option value="">Select Class</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.className}
                      </option>
                    ))}
                  </select>
                </div>
                 {/* Input with magnifier icon */}
              <div> 
                <label className="font-medium">Section</label>
                <div className="w-full border rounded px-2 py-1 flex items-center">
                  <input
                    type="text"
                    value={selectedStudentAcademic.sectionName}
                    disabled
                    className="flex-grow focus:outline-none"
                    placeholder="Select Section..."
                    onChange={(e) =>
                      setSelectedStudentAcademic({
                        ...selectedStudentAcademic,
                        sectionName: e.target.value,
                      })
                    }
                  />
                  <button
                    onClick={() => setActiveLookup("SECTION")}
                    className="text-gray-500 hover:text-blue-600"
                  >
                    <FaSearch />
                  </button>
                </div>

                <Lookup isOpen={activeLookup === "SECTION"} onClose={() => setActiveLookup(null)}
                    onSelect={(sec) => setSelectedStudentAcademic({ ...selectedStudentAcademic, sectionId: sec.id, sectionName: sec.name })} 
                    lookupConfig={{ type: "SECTION", attributes: { id: selectedStudentAcademic.classId} }} 
                    inputValue={selectedStudentAcademic.classId}/>
                </div>


                <div>
                  <label className="font-medium">Active</label>
                  <select
                    value={selectedStudentAcademic.isActive}
                    onChange={handleChange}
                    name="isActive"
                    className="w-full border rounded px-2 py-1"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                 <div>
                  <label className="font-medium">Fees Status</label>
                  <input
                    type="text"
                     onChange={handleChange} disabled
                     name="feeStatus"
                    value={selectedStudentAcademic.feeStatus || "Pending"}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                {/* <div>
                  <p className="font-medium">Pending Fee</p>
                  <span className="inline-block mt-1 px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-semibold">
                    {selectedStudentAcademic.pendingFee ||0.0}
                  </span>
                </div> */}

                {/* Address full row */}
                {/* <div className="col-span-3">
                  <label className="font-medium">Address</label>
                  <textarea
                    value={selectedStudentAcademic.student.address || ""}
                    className="w-full border rounded px-2 py-1"
                    rows="2"
                  />
                </div> */}

              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3">
                <button
                  onClick={onClosePopup}
                  className="px-4 py-2 bg-gray-200 rounded"
                >
                  Cancel
                </button>

                <button className="px-4 py-2 bg-blue-600 text-white rounded"
                 onClick={handleSave}>
                  Save
                </button>
              </div>

            </div>
          </div>
        )}
        {showPaymentDetails && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 sm:mx-0 overflow-y-auto max-h-[90vh]">
              <div className="p-4 border-b flex justify-between items-center">
                <h2 className="text-lg font-semibold">Fees</h2>
                <button
                  onClick={() => setShowPaymentDetails(false)}
                  className="text-gray-500 hover:text-red-600"
                >
                  ✕
                </button>
              </div>
              <div className="p-4">
                {/* Reuse your existing StudentDetails component here */}
                {/* <StudentFeeDetails studentId={selectedStudentAcademic.studentId} /> */}
                <StudentFeeDetails  />
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
}